<div class="private-form">
  <div class="center-block">
    <header class="private-header">
      <div class="logo-wrapper">
        <img [src]="logo.src" alt="logo" class="logo" />
      </div>
      <h1 class="store-welcome">{{ storeWelcome }}</h1>
    </header>
    <main class="private-main">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        @if (!ssoEnabled) {
          @if (promoCodeAccess && !passwordAccess) {
            <h2>{{ 'PRIVATE.enterGiftCard' | translate }}</h2>
          } @else if (passwordAccess && !promoCodeAccess) {
            <h2>{{ 'PRIVATE.enterPassword' | translate }}</h2>
          } @else if (passwordAccess && promoCodeAccess) {
            <h2>{{ 'PRIVATE.both' | translate }}</h2>
          }
          <div class="flex justify-content-center">
            <div class="flex flex-column gap-2 w-23rem">
              <app-input [name]="'Code'" [control]="form.controls.card"></app-input>
              <div class="mt-3">
                <app-button
                  type="submit"
                  label="{{ 'COMMON.enter' | translate }}"
                  [fullWidth]="true"
                ></app-button>
              </div>
            </div>
          </div>
        } @else {
          <h2>{{ 'PRIVATE.SSO' | translate }}</h2>
          <div class="flex justify-content-center">
            <div class="flex flex-column gap-2 w-23rem">
              @if (ssoProvider === 'microsoft') {
                <div class="microsoft-entra-login">
                  <button
                    type="button"
                    (click)="onMicrosoftEntraLogin()"
                    class="microsoft-entra-login-btn"
                  >
                    <img
                      src="assets/img/icons/microsoft.svg"
                      alt="Microsoft icon"
                      class="microsoft-icon"
                    />
                    Microsoft
                  </button>
                </div>
              }
              @if (ssoProvider === 'okta') {
                <div class="sso-login">
                  <button type="button" (click)="onOktaLogin()" class="sso-login-btn">
                    <img src="assets/img/icons/okta.svg" alt="Okta icon" class="sso-icon" />
                    Okta
                  </button>
                </div>
              }
              <nav class="legal-links" aria-label="Legal">
                <a routerLink="/private/privacy-policy">Privacy Policy</a>
                <a routerLink="/private/terms-and-conditions">Terms and Conditions</a>
              </nav>
            </div>
          </div>
        }
      </form>
    </main>
  </div>
</div>
